// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Badge-Badge-module__Badge";
var _2 = "webpack-components-core-Badge-Badge-module__danger";
var _3 = "webpack-components-core-Badge-Badge-module__lg";
var _4 = "webpack-components-core-Badge-Badge-module__md";
var _5 = "webpack-components-core-Badge-Badge-module__neutral";
var _6 = "webpack-components-core-Badge-Badge-module__outline";
var _7 = "webpack-components-core-Badge-Badge-module__primary";
var _8 = "webpack-components-core-Badge-Badge-module__sm";
var _9 = "webpack-components-core-Badge-Badge-module__solid";
var _a = "webpack-components-core-Badge-Badge-module__subtle";
var _b = "webpack-components-core-Badge-Badge-module__success";
var _c = "webpack-components-core-Badge-Badge-module__warning";
var _d = "webpack-components-core-Badge-Badge-module__xl";
var _e = "webpack-components-core-Badge-Badge-module__xs";
export { _1 as "Badge", _2 as "danger", _3 as "lg", _4 as "md", _5 as "neutral", _6 as "outline", _7 as "primary", _8 as "sm", _9 as "solid", _a as "subtle", _b as "success", _c as "warning", _d as "xl", _e as "xs" }
